import type { SiteInspection, User } from '@shared/schemas'
import type { PageProps, QueryDefinition } from '@/core'
import type { SiteInspectionsFormValues } from './form'
import type { SiteInspectionsVariables } from './variables'

export const SITE_INSPECTION_KEYS = {
  all: ['site-inspections'] as const,
  list: () => [...SITE_INSPECTION_KEYS.all].join('/'),
  detail: (id: string) => [...SITE_INSPECTION_KEYS.all, id].join('/'),
  search: (query: string, limit?: number) =>
    [...SITE_INSPECTION_KEYS.all, 'search', query, limit].join('/'),
}

export const SITE_INSPECTION_ENDPOINTS = {
  list: ['api', 'registry/site-inspections'] as [string, string],
  delete: (id: string): [string, string] => [
    'api',
    `registry/site-inspections/${id}`,
  ],
  create: ['api', 'registry/site-inspections'] as [string, string],
  update: (id: string): [string, string] => [
    'api',
    `registry/site-inspections/${id}`,
  ],
  detail: (id: string): [string, string] => [
    'api',
    `registry/site-inspections/${id}`,
  ],
}

export type SiteInspectionsQueryDefinition = [
  QueryDefinition<'siteInspections', 'query', void, Array<SiteInspection>>,
  QueryDefinition<'doctors', 'query', void, Array<User>>,
]

export const siteInspectionsQueries: NonNullable<
  PageProps<
    SiteInspectionsFormValues,
    SiteInspectionsQueryDefinition,
    SiteInspectionsVariables
  >['queries']
> = [
  {
    key: 'siteInspections',
    type: 'query',
    queryConfig: () => ({
      queryKey: [SITE_INSPECTION_KEYS.list()],
      endpoint: ['api', 'registry/site-inspections'],
      enabled: true,
    }),
  },
  {
    key: 'doctors',
    type: 'query',
    queryConfig: {
      queryKey: ['site-inspections/doctors'],
      endpoint: ['api', 'users?role=doctor'],
      enabled: true,
    },
  },
]
